(<template>
  <div class="form">
    <i class="loading"></i>
  </div>
</template>)

(<script>
import axios from 'axios'

export default {
  name: 'sign-out',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$session.exists()) {
        next()
      } else {
        next('/signin')
      }
    })
  },
  created () {
    axios({
      method: 'post',
      url: `${process.env.SERVER_URL}/auth/logout`,
      withCredentials: true
    })
    .then(() => {
      this.$session.destroy()
      window.location = '/'
      this.$message({
        type: 'success',
        message: this.$gettext('Signed out')
      })
    })
    .catch(error => {
      var msg
      if (error.response) {
        msg = error.response.data || error.response.statusText
      } else {
        msg = error.message
      }
      this.$message({
        type: 'error',
        message: msg
      })
    })
  }
}
</script>)



// WEBPACK FOOTER //
// src/components/Sign-Out.vue